// const Login = () => {
// 	const dispatch = useAppDispatch()
// 	const [loginCredentials, setLoginCredentials] = useState({ email: '', password: '' } as LoginRequest)
// 	const { token, error } = useAppSelector(state => state.auth)
// 	const [redirectToDashboard, setRedirectToDashboard] = useState(false)
// 	const handleChange = (e: FormEvent<HTMLInputElement>) => {
// 		setLoginCredentials({ ...loginCredentials, [e.currentTarget.name]: e.currentTarget.value })
// 	}

// 	const handleLogin = (e: SyntheticEvent) => {
// 		e.preventDefault()
// 		if (error) {
// 			dispatch(clearError())
// 		}
// 		dispatch(login({ ...loginCredentials }))
// 	}

// 	useEffect(() => {
// 		if (token && token !== "") {
// 			setRedirectToDashboard(true)
// 		}
// 	}, [token])

// 	useEffect(() => {
// 		if(error) {
// 			setTimeout(() => {
// 				dispatch(clearError())
// 			  }, 5000)
// 		}
// 	}, [error])

// 	return redirectToDashboard ?
// 		<Redirect to={"/"} />
// 		:
// 		(
// 			<div>
// 				<form className="w-25 mx-auto" onSubmit={handleLogin}>
// 					{error &&
// 						<div className="row mb-3 alert alert-danger">
// 							{error}
// 						</div>
// 					}
// 					<div className='mb-3 row'>
// 						<label htmlFor='staticEmail' className='col-sm-5 col-form-label'>Email</label>
// 						<div className='col-sm-7'>
// 							<input type='text' name='email' onChange={handleChange} className='form-control' id='staticEmail' value={loginCredentials?.email} />
// 						</div>
// 					</div>
// 					<div className='mb-3 row'>
// 						<label htmlFor='inputPassword' className='col-sm-5 col-form-label'>Password</label>
// 						<div className='col-sm-7'>
// 							<input type='password' name='password' onChange={handleChange} className='form-control' id='inputPassword' value={loginCredentials?.password} />
// 						</div>
// 					</div>
// 					<div className='mb-3 row'>
// 						<button className="btn btn-primary " type="submit">Submit</button>
// 					</div>
// 				</form>
// 			</div>
// 		)
// }

// export default Login
import React, { useEffect, useState } from "react"
import { Button, Col, Form, FormControl, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Redirect } from "react-router"
import { ErrorObject } from "../../api"
// import { SyntheticEvent } from 'hoist-non-react-statics/node_modules/@types/react'
import { LoginRequest } from "../../api/login.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import logo from "../../assets/logo.svg"
import { RootState } from "../../store"
import { clearError, login } from "../../store/auth.store"

function Login() {
    const { t } = useTranslation()
    const [validated, setValidated] = useState(false)

    const dispatch = useAppDispatch()
    const [loginCredentials, setLoginCredentials] = useState({ identity: "", password: "" } as LoginRequest)
    const { isAuthed, error } = useAppSelector((state: RootState) => state.auth)
    const [redirectToFirstPage, setRedirectToFirstPage] = useState(false)

    const handleSubmit = (e: any) => {
        e.preventDefault()
        dispatch(login({ ...loginCredentials }))
    }

    useEffect(() => {
        if (isAuthed) {
            setRedirectToFirstPage(true)
        }
    }, [isAuthed])

    useEffect(() => {
        if (error) {
            setTimeout(() => {
                dispatch(clearError())
            }, 5000)
        }
    }, [error, validated])

    return isAuthed ? (
        <Redirect to={"/"} />
    ) : (
        <>
            <div className="text-center pt-3">
                <img className={"logo m-auto"} src={logo} alt={t("Logo")} />
                <div className="logo-text my-4">{t("Sign_In_Text")}</div>
            </div>
            <div className="container-fluid p-4 w-100">
                <Form validated={validated} onSubmit={handleSubmit} className="form">
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Form.Group className="mt-2" controlId="username">
                                <Form.Label className="mb-3">{t("username")}</Form.Label>
                                <Form.Control
                                    type={"text"}
                                    placeholder={t("Username_Placeholder")}
                                    name="identity"
                                    required={true}
                                    onChange={(e: Record<string, any>) => {
                                        const form = e.currentTarget
                                        setLoginCredentials({
                                            ...loginCredentials,
                                            [e.target.name]: e.target.value
                                        })
                                        if (form.checkValidity() === false) {
                                            e.stopPropagation()
                                        }

                                        setValidated(true)
                                    }}
                                />
                                <FormControl.Feedback type="invalid">
                                    {t("Username_Error")}
                                </FormControl.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Form.Group className="mt-2" controlId="Password">
                                <Form.Label className="mb-3">{t("Password")}</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder={t("Password_Placeholder")}
                                    name="password"
                                    required={true}
                                    onChange={(e: Record<string, any>) => {
                                        const form = e.currentTarget
                                        setLoginCredentials({
                                            ...loginCredentials,
                                            [e.target.name]: e.target.value
                                        })
                                        if (form.checkValidity() === false) {
                                            e.stopPropagation()
                                        }
                                        setValidated(true)
                                    }}
                                />
                                <FormControl.Feedback type="invalid">
                                    {t("Password_Error")}
                                </FormControl.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        {error?.payload && error?.payload?.length > 0 ? (
                            error.payload?.map((e: ErrorObject, index: number) => (
                                <div className="error" key={`${index}-${e.param}`}>
                                    {e.msg}
                                </div>
                            ))
                        ) : (
                            <div className="error">{error?.error}</div>
                        )}
                    </Row>
                    <Row className="my-3">
                        <Col xs={12} sm={12} md={12} lg={12} className="text-right">
                            <Button type="submit" className="submit-button">
                                {t("Login")}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    )
}

export default Login
